import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/app/_layout/analytics")({
	beforeLoad: ({ location }) => {
		if (location.pathname === "/app/analytics")
			throw redirect({ to: "/app/analytics/overview" });
	},
});
